const resources = {
  "en": {
    "tempoMint": {
      "title": "TempoMint",
      "description": "Convert money into time and plan your effort with instant hourly insights.",
      "cards": {
        "calculatorTitle": "Money ↔ hours calculator",
        "calculatorDescription": "Use your saved hourly rate or a custom one, then keep the conversions you want to revisit.",
        "historyTitle": "Conversion history",
        "historyDescription": "Recent saved conversions stay here so you can compare time, money, and notes in one place."
      },
      "snapshot": {
        "title": "Tempo snapshot",
        "caption": "Keep the active rate, current mode, and saved calculations visible before diving into the converter.",
        "rate": "Active hourly rate",
        "rateHelper": "This rate drives the current conversion view.",
        "rateEmpty": "Not set",
        "mode": "Current mode",
        "modeMyRate": "Uses the hourly rate from your profile settings.",
        "modeCustomRate": "Uses the custom rate entered in this calculator.",
        "saved": "Saved results",
        "savedHelper": "Stored conversions you can revisit or delete later."
      },
      "modeLabel": "Mode",
      "modes": {
        "myRate": "My rate",
        "customRate": "Custom rate"
      },
      "info": {
        "myRateDisabledTitle": "Hourly rate missing",
        "myRateDisabledDescription": "Open profile settings and add your hourly rate to unlock the \"My rate\" mode.",
        "saveHint": "Only \"My rate\" conversions can be saved. Switch to that mode and enter values to enable the save button."
      },
      "currentRateLabel": "Active hourly rate",
      "currentRate": "{{value}} per hour",
      "currentRateEmpty": "Specify an hourly rate to start converting.",
      "fields": {
        "amount": "Money amount",
        "hours": "Hours",
        "rate": "Hourly rate",
        "note": "Note"
      },
      "placeholders": {
        "amount": "Enter amount",
        "hours": "Enter hours",
        "rate": "Enter hourly rate",
        "note": "Add a note (optional)"
      },
      "help": {
        "rate": "Use this hourly rate for all conversions.",
        "note": "Store up to {{limit}} characters together with each saved conversion."
      },
      "errors": {
        "rateRequired": "Hourly rate must be greater than 0."
      },
      "actions": {
        "save": "Save result",
        "saving": "Saving...",
        "refresh": "Refresh",
        "delete": "Delete",
        "cancel": "Cancel",
        "confirmDelete": "Delete this result?"
      },
      "notifications": {
        "loadFailed": "Failed to load saved results",
        "saveFailed": "Failed to save result",
        "saved": "Result saved",
        "deleteFailed": "Failed to delete result",
        "deleted": "Result deleted",
        "noteTooLong": "Note is too long"
      },
      "history": {
        "savedEmpty": "No saved calculations yet. Use the calculator and save your favourite results.",
        "mode": {
          "myRate": "My rate",
          "customRate": "Custom rate"
        },
        "source": {
          "money": "Entered amount: {{value}}",
          "hours": "Entered hours: {{value}}"
        }
      }
    }
  },
  "uk": {
    "tempoMint": {
      "title": "TempoMint",
      "description": "Перетворюйте гроші на час і плануйте свої зусилля завдяки миттєвим погодинним підрахункам.",
      "cards": {
        "calculatorTitle": "Калькулятор гроші ↔ години",
        "calculatorDescription": "Використовуйте збережену погодинну ставку або власну, а потім залишайте під рукою потрібні конверсії.",
        "historyTitle": "Історія конверсій",
        "historyDescription": "Тут зберігаються останні конверсії, щоб можна було швидко звірити час, гроші й нотатки."
      },
      "snapshot": {
        "title": "Знімок Tempo",
        "caption": "Активна ставка, поточний режим і збережені розрахунки видно ще до того, як ви зануритесь у калькулятор.",
        "rate": "Активна погодинна ставка",
        "rateHelper": "Саме ця ставка використовується в поточному розрахунку.",
        "rateEmpty": "Не вказано",
        "mode": "Поточний режим",
        "modeMyRate": "Використовується погодинна ставка з налаштувань профілю.",
        "modeCustomRate": "Використовується власна ставка, введена в цьому калькуляторі.",
        "saved": "Збережені результати",
        "savedHelper": "Розрахунки, до яких можна повернутися або видалити пізніше."
      },
      "modeLabel": "Режим",
      "modes": {
        "myRate": "Моя ставка",
        "customRate": "Власна ставка"
      },
      "info": {
        "myRateDisabledTitle": "Погодинна ставка відсутня",
        "myRateDisabledDescription": "Відкрийте налаштування профілю та додайте свою погодинну ставку, щоб розблокувати режим «Моя ставка».",
        "saveHint": "Лише конверсії «Моя ставка» можна зберігати. Перемкніться на цей режим і введіть значення, щоб активувати кнопку збереження."
      },
      "currentRateLabel": "Активна погодинна ставка",
      "currentRate": "{{value}} за годину",
      "currentRateEmpty": "Вкажіть погодинну ставку, щоб почати конвертацію.",
      "fields": {
        "amount": "Сума грошей",
        "hours": "Години",
        "rate": "Погодинна ставка",
        "note": "Нотатка"
      },
      "placeholders": {
        "amount": "Введіть суму",
        "hours": "Введіть години",
        "rate": "Введіть погодинну ставку",
        "note": "Додайте нотатку (необов’язково)"
      },
      "help": {
        "rate": "Використовуйте цю погодинну ставку для всіх конверсій.",
        "note": "Зберігайте до {{limit}} символів разом з кожною збереженою конверсією."
      },
      "errors": {
        "rateRequired": "Погодинна ставка має бути більшою за 0."
      },
      "actions": {
        "save": "Зберегти результат",
        "saving": "Збереження...",
        "refresh": "Оновити",
        "delete": "Видалити",
        "cancel": "Скасувати",
        "confirmDelete": "Видалити цей результат?"
      },
      "notifications": {
        "loadFailed": "Не вдалося завантажити збережені результати",
        "saveFailed": "Не вдалося зберегти результат",
        "saved": "Результат збережено",
        "deleteFailed": "Не вдалося видалити результат",
        "deleted": "Результат видалено",
        "noteTooLong": "Нотатка занадто довга"
      },
      "history": {
        "savedEmpty": "Збережених обчислень ще немає. Скористайтеся калькулятором і збережіть улюблені результати.",
        "mode": {
          "myRate": "Моя ставка",
          "customRate": "Власна ставка"
        },
        "source": {
          "money": "Введена сума: {{value}}",
          "hours": "Введені години: {{value}}"
        }
      }
    }
  }
};

export default resources;
